import locale from "../../../../locale";

export const SIDEBAR_POSITION = 'sidebarPosition';

export const SIDEBAR_POSITION_OPTIONS = [
    {
        label: `${locale('settings.right')}`,
        value: 'right',
    },
    {
        label: `${locale('settings.bottom')}`,
        value: 'bottom',
    },
];
